import { render, staticRenderFns } from "./PortTabs.vue?vue&type=template&id=1fe67fdf&scoped=true"
import script from "./PortTabs.vue?vue&type=script&lang=js"
export * from "./PortTabs.vue?vue&type=script&lang=js"
import style0 from "./PortTabs.vue?vue&type=style&index=0&id=1fe67fdf&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fe67fdf",
  null
  
)

export default component.exports